"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomToolTip_1 = __importDefault(require("@Components/CustomToolTip"));
const react_1 = __importDefault(require("react"));
const ValueBandsToolTip_1 = __importDefault(require("@Components/MatchComponents/ValueBandsToolTip"));
const RecordingGroupGridHeader = ({ isPendingStatus, isRejectedStatus }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("div", { className: 'cell-padding-left', role: 'columnheader' }, "ISRC"),
    react_1.default.createElement("div", { role: 'columnheader' }, "Recording Title"),
    react_1.default.createElement("div", { role: 'columnheader' }, "Recording Artist"),
    react_1.default.createElement("div", { role: 'columnheader' },
        "DSP Supplied Writers",
        react_1.default.createElement(CustomToolTip_1.default, { type: '?', inverse: true, info: 'Writers listed in this column are the result of information provided by the DSP' })),
    isPendingStatus && (react_1.default.createElement("div", { role: 'columnheader', className: 'cell-padding-left' },
        "Estimated Value",
        react_1.default.createElement(ValueBandsToolTip_1.default, { inverseColor: true }))),
    isRejectedStatus && react_1.default.createElement("div", { role: 'columnheader' }, "Rejection Reason"),
    react_1.default.createElement("div", { className: 'cell-padding-right', role: 'columnheader' }, "\u00A0")));
exports.default = RecordingGroupGridHeader;
